export default Object.freeze({
  /**
   * Server responded with 500 status code or some other unrecoverable error
   */
  INTERNAL_SERVER_ERROR: {
    id: 'internalServerError',
    statusCode: 500,
    routeName: 'ErrorPage',
  },
  /**
   *  Resource or page was not found
   */
  PAGE_NOT_FOUND: {
    id: 'pageNotFoundError',
    statusCode: 404,
    routeName: 'NotFoundPage',
  },
  /**
   * User is not authenticated
   */
  UNAUTHORIZED: {
    id: 'unAuthorizedError',
    statusCode: 401,
    routeName: 'UnauthorizedPage',
  },
  /**
   * User is not authorized to access resource
   */
  FORBIDDEN: {
    id: 'forbiddenError',
    statusCode: 403,
    routeName: 'ForbiddenPage',
  },
  /**
   * Generic page for bad request responses (400)
   */
  BAD_REQUEST: {
    id: 'badRequestError',
    statusCode: 400,
    routeName: 'ErrorPage',
  },
  /**
   * Similar to 401 but can provide more reasoning as to why a certain action was blocked
   */
  ACTION_LOCKED: {
    id: 'accountLockedError',
    statusCode: 401,
    routeName: 'ActionLocked',
  },
  /**
   * For scenarios when the user's account couldn't be retrieved from the server
   */
  ACCOUNT_LOAD_FAILURE: {
    id: 'accountLoadError',
    statusCode: 400,
    routeName: 'AccountLoadFailedPage',
  },
  /**
   * For expired access tokens etc
   */
  EXPIRED: {
    id: 'expiredError',
    statusCode: 410,
    routeName: 'ErrorPage',
  },
  /**
   * For expired access tokens etc
   */
  NO_SERVER_RESPONSE: {
    id: 'noServerResponseError',
    statusCode: 500,
    routeName: 'NoServerResponsePage',
  },
})
